import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithDecryption } from "../baseQueryWithEncryption";

const jiraProjectApi = createApi({
  reducerPath: "jiraProjectApi",
  baseQuery: baseQueryWithDecryption(import.meta.env.VITE_API_BASE_URL),

  tagTypes: ["JiraProject"],
  endpoints: (build) => ({
    getJiraProjectList: build.query({
      query: () => "/project-configs",
    }),
    getProjectForDropDown: build.query({
      query: () => "/jira/projects",
    }),
    getUserListForAProject: build.query({
      query: ({ projectId }) => `/project-config/${projectId}`,
    }),
    // generateApiKey: builder.mutation({
    //     query: (deptName) => ({
    //       url: `api-key/generate`,
    //       method: "POST",
    //       body: {
    //         deptName,
    //       },
    //     }),
    //     invalidatesTags: ["apiKeys"],
    //   }),
    addUserInToProject: build.mutation({
      query: (data) => ({
        url: `/project-config`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["JiraProject"],
    }),
    getAzureBoardsProjects: build.query({
      query: ({ companyId }) => `/azure-boards/projects?companyId=${companyId}`,
    }),
  }),
});
export const {
  useGetJiraProjectListQuery,
  useGetProjectForDropDownQuery,
  useGetUserListForAProjectQuery,
  useAddUserInToProjectMutation,
  useGetAzureBoardsProjectsQuery,
} = jiraProjectApi;
export default jiraProjectApi;
